<!-- 
| Ini adalah component root dari halaman Dashboard Klien. 
| Hampir semua data di get-nya dari sini lalu diparsing ke komponen childnya.
|
| @author   : Ronaldo Simanjuntak
| @company  : PT Kabayan Aishwarya Nusantara
| @app      : Online Media Monitoring
| @version  : 3.0.0
-->

<template>
  <div id="dashboard-kabayan-page" class="row">
    <!-- HEADER -->
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
      <page-header-component v-if="topics" :topics="topics" title="Dashboard" />
    </div>
    <!-- SCORE CARD -->
    <!-- Cek card.vue di direktori component untuk detail parameter dan cara kerjanya -->
    <transition name="block">
      <div v-show="mounted" class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class="row">
          <div
            class="col-md-6"
            style="padding: 10px !important"
            id="cardMention"
          >
            <div class="row bg-white">
              <div class="col-md-4">
                <loader-component v-if="isLoading" />
                <card-dynamic-component
                  v-else
                  card_title="Mention"
                  :card_content="stats != null ? stats.mention : '0'"
                  number_color="purple"
                  card_icon="bi bi-chat-dots-fill"
                />
              </div>
              <div class="col-md-4">
                <loader-component v-if="isLoading" />
                <card-dynamic-component
                  v-else
                  card_title="Reach"
                  :card_content="stats != null ? stats.reach : '0'"
                  number_color="orange"
                  card_icon="bi bi-megaphone"
                />
              </div>
              <div class="col-md-4">
                <loader-component v-if="isLoading" />
                <card-dynamic-component
                  v-else
                  card_title="Engagement"
                  :card_content="stats != null ? stats.engagement : '0'"
                  number_color="cyan"
                  card_icon="bi bi-share-fill"
                />
              </div>
            </div>
          </div>
          <div
            class="col-md-6"
            style="padding: 10px !important"
            id="cardSentimen"
          >
            <div class="row bg-white">
              <div class="col-md-4">
                <loader-component v-if="isLoading" />
                <card-dynamic-component
                  v-else
                  card_title="Sentimen Positif"
                  :card_content="stats != null ? stats.positif : '0'"
                  :dalam_kurung="
                    stats != null ? stats.persentase.positif + '%' : '0%'
                  "
                  number_color="success"
                  card_icon="bi bi-emoji-smile"
                />
              </div>
              <div class="col-md-4">
                <loader-component v-if="isLoading" />
                <card-dynamic-component
                  v-else
                  card_title="Sentimen Netral"
                  :card_content="stats != null ? stats.netral : '0'"
                  :dalam_kurung="
                    stats != null ? stats.persentase.netral + '%' : '0%'
                  "
                  number_color="complete"
                  card_icon="bi bi-emoji-neutral"
                />
              </div>
              <div class="col-md-4">
                <loader-component v-if="isLoading" />
                <card-dynamic-component
                  v-else
                  card_title="Sentimen Negatif"
                  :card_content="stats != null ? stats.negatif : '0'"
                  :dalam_kurung="
                    stats != null ? stats.persentase.negatif + '%' : '0'
                  "
                  number_color="danger"
                  card_icon="bi bi-emoji-frown"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- LINE CHART DAN SOURCES -->
    <!-- widget untuk menampilkan grafik tren mention dan search dan sources list -->
    <transition name="block">
      <div
        v-show="mounted"
        class="col-md-12 col-sm-12 col-lg-12 m-b-10"
        id="grafikLine"
      >
        <medsos-tren-mention-component
          :key="sources_key"
          :data_line_chart="data_tren"
          :data_source="sources"
          :is-loading="isLoading"
        />
      </div>
    </transition>

    <!-- BAR CHART DAN TOP POSTS -->
    <transition name="block">
      <div
        v-show="mounted"
        class="col-md-12 col-sm-12 col-lg-12"
        id="grafikBar"
      >
        <medsos-sentiment-post-component
          :key="g_topik_key"
          :data_grafik="data_topik"
        />
      </div>
    </transition>
    <div class="clearfix" />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import card_dynamic from "@/views/components/dashboard/card_dynamic.vue";
import medsos_tren_mention from "@/views/components/dashboard/medsos_tren_mention.vue";
import medsos_sentiment_post from "@/views/components/dashboard/medsos_sentiment_post.vue";
import loader_component from "@/views/components/loader.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "Home",
  title: "Dashboard | Online Media Monitoring",
  components: {
    "card-dynamic-component": card_dynamic,
    "page-header-component": page_header,
    "medsos-tren-mention-component": medsos_tren_mention,
    "medsos-sentiment-post-component": medsos_sentiment_post,
    "loader-component": loader_component,
  },
  data() {
    return {
      resp: null,
      isLoading: true,
      query: null,
      stats: null,
      sources: null,
      data_tren: null,
      data_topik: null,
      mounted: false,
      sources_key: 0,
      g_topik_key: 0,
      id_project: this.$store.getters.user.id_project,
      topics: null,
      type: this.$store.getters.user.project.project_detail.tipe,
      tour_steps: [],
    };
  },
  methods: {
    getData: function () {
      var params = this.$route.query;
      let self = this;
      let query;
      if ("sources" in params) {
        delete params.sources;
      }
      if ("from" in params && "to" in params) {
        query = Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
      } else {
        params = this.$route.query;
        if ("from" in params && "to" in params) {
          this.getData();
        } else {
          params = gp.getDateTujuhHariTerakhirDefault("YYYY-MM-DD HH:mm:ss");
          query = Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&");
        }
      }
      if (this.query != query) {
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "dashboard-classic/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then((response) => {
            if (response.status != 204) {
              self.resp = response.data;

              self.data_topik = self.resp.bar_topik;
              self.g_topik_key++;

              self.data_tren = self.resp.trend ? self.resp.trend : {};
              self.setScoreCardStats();
              self.setSourceData();
            } else {
              self.isLoading = false;
              self.stats = null;
              self.sources = [];
              self.sources["blogs"] = 0;
              self.sources["facebook"] = 0;
              self.sources["forum"] = 0;
              self.sources["instagram"] = 0;
              self.sources["news"] = 0;
              self.sources["twitter"] = 0;
              self.sources["youtube"] = 0;

              self.data_tren = {};
              self.data_topik = {};

              self.sources_key++;
              self.g_topik_key++;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(function () {
            self.isLoading = false;
          });
      }
    },
    setScoreCardStats: function () {
      let resp = this.resp.stats;
      if (resp != null && typeof resp !== "undefined") {
        this.stats = {};
        this.stats.mention = resp.total.toString();
        this.stats.reach = resp.esmr.toString();
        this.stats.engagement = resp.engagement.toString();
        this.stats.positif = resp.positif.toString();
        this.stats.netral = resp.netral.toString();
        this.stats.negatif = resp.negatif.toString();

        let total_sentimen =
          parseInt(this.stats.positif) +
          parseInt(this.stats.netral) +
          parseInt(this.stats.negatif);
        this.stats.persentase = {
          positif:
            total_sentimen > 0
              ? this.decimalFix((this.stats.positif / total_sentimen) * 100)
                  .toString()
                  .replace(".", ",")
              : 0,
          netral:
            total_sentimen > 0
              ? this.decimalFix((this.stats.netral / total_sentimen) * 100)
                  .toString()
                  .replace(".", ",")
              : 0,
          negatif:
            total_sentimen > 0
              ? this.decimalFix((this.stats.negatif / total_sentimen) * 100)
                  .toString()
                  .replace(".", ",")
              : 0,
        };
      }
    },
    setSourceData: function () {
      let sources = [];
      sources["twitter"] = this.resp.stats.twitter;
      sources["facebook"] = this.resp.stats.facebook;
      sources["instagram"] = this.resp.stats.instagram;
      sources["youtube"] = this.resp.stats.youtube;
      sources["news"] = this.resp.stats.news;
      sources["forum"] = this.resp.stats.forum;
      sources["blog"] = this.resp.stats.blog;
      this.sources = sources;
      this.sources_key++;
    },
    decimalFix: function (value) {
      return value.toFixed(2);
    },
    updateUrlQuery: function (key, value) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries[key] = value;
      this.$router.replace({ query: queries });
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getData();
        });
    },
  },
  watch: {
    $route() {
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query && query != "") {
        this.isLoading = true;
        this.getData();
      }
    },
  },
  mounted: function () {
    this.mounted = true;
    this.getTopic();
    let v_step = [];
    if (this.type == 2) {
      v_step[0] = {
        target: "#page-header-select",
        header: {
          title: "Filter Topik",
        },
        content: `Digunakan untuk memfilter data berdasarkan topik`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[1] = {
        target: "#reportrange",
        header: {
          title: "Filter Periode",
        },
        content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[2] = {
        target: "#cardMention",
        header: {
          title: "Jumlah",
        },
        content:
          "Menampilkan jumlah mention,reach,engagemnt dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[3] = {
        target: "#cardSentimen",
        header: {
          title: "Jumlah Sentimen",
        },
        content:
          "Menampilkan jumlah Sentimen dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[4] = {
        target: '[data-v-step="7"]',
        header: {
          title: "Grafik Tren Mention, Reach dan Engagement",
        },
        content:
          "Menampilkan Grafik Tren Mention, Reach dan Engagement dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[5] = {
        target: '[data-v-step="8"]',
        header: {
          title: "Sources",
        },
        content:
          "Menampilkan jumlah Tren Sources dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[6] = {
        target: '[data-v-step="9"]',
        header: {
          title: "Sentimen",
        },
        content:
          "Menampilkan komparasi sentimen dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[7] = {
        target: '[data-v-step="10"]',
        header: {
          title: "Posting",
        },
        content:
          "Menampilkan Posting Terbaru dan Terpopuler dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
    }
    this.tour_steps = v_step;
  },
};
</script>

<style>
.bg-white {
  background-color: white;
}
</style>